<div style="user-select: none;"
    class="menu_item" (click)="selectMenu()">
    <div class="menu-icon"  [ngClass]="{'active-menu-icon':isHighlighted}">
        <span class="material-symbols-outlined font-18">
            {{icon_name}}
        </span>
    </div>
    <label class="m-0 ml-3 menu-label" [ngClass]="{'active-menu-label':isHighlighted}">{{title}}</label>
</div>